module.exports = __webpack_public_path__ + "static/media/certified-shield.f7fb5843.png";